import React, { memo, useCallback } from 'react'
import tw from 'twin.macro'
import { Tags } from 'src/components/tags/Tags'
import { Tag } from 'src/interfaces/tag'
import { useDispatch } from 'react-redux'
import { createAsyncAction } from 'src/utils/reduxUtils'
import { MCAddTag, MCDeleteTag } from 'src/constants/actionTypes'
import { showToast } from 'src/utils/toast'
import { handleApiError } from 'src/utils/errorHandlers'
import { MCDetails } from 'src/interfaces/mc'

interface AddOnsTabProps {
  mcDetails: MCDetails
  onUpdate(): void | Promise<void>
}

const AddOnsTabComponent = ({ mcDetails, onUpdate }: AddOnsTabProps) => {
  const dispatch = useDispatch()

  const handleSelectTag = useCallback(
    async (newTag: Tag) => {
      try {
        await createAsyncAction(
          dispatch,
          MCAddTag.request({
            tagId: newTag.id,
            masterContractorRelationId: mcDetails.masterContractorRelationId,
          }),
        )

        await onUpdate()

        showToast('Tag is added.')
      } catch (err: any) {
        handleApiError(err)
      }
    },
    [mcDetails, onUpdate, dispatch],
  )

  const handleRemoveTag = useCallback(
    async (removedTag: Tag) => {
      try {
        await createAsyncAction(
          dispatch,
          MCDeleteTag.request({
            tagId: removedTag.id,
            masterContractorRelationId: mcDetails.masterContractorRelationId,
          }),
        )

        await onUpdate()

        showToast('Tag is removed.')
      } catch (err: any) {
        handleApiError(err)
      }
    },
    [mcDetails, onUpdate, dispatch],
  )

  return (
    <div css={tw`flex flex-1 flex-col p-4 overflow-y-scroll h-full bg-[rgba(246, 246, 246, 1)]`}>
      <div css={tw`bg-white rounded-2xl px-4 py-1 overflow-hidden`}>
        <Tags
          tags={mcDetails.tags}
          className={tw`py-3`}
          onSelectTag={handleSelectTag}
          onRemoveTag={handleRemoveTag}
        />
      </div>
    </div>
  )
}

export const AddOnsTab = memo(AddOnsTabComponent)
